import { useTranslation } from "react-i18next";
import { IconButton, Modal, Tooltip } from "@mui/material";
import { useStyle } from "./style";
import { RoundedCloseIcon } from "./icon/close";
import { CloseIcon } from "@/widgets/quote-new/receipts-table/Payment-methods-details/icons/close-icon";

const GoMakeModal = ({
  openModal,
  onClose,
  withClose = true,
  withRoundedCloseIcon = false,
  isMiddleTitle = false,
  insideStyle,
  contentStyle,
  contentClassName,
  modalTitle,
  modalTitleStyle,
  modalDescription,
  isBlockModal,
  modalTitleColor,
  headerPadding = 0,
  headerPaddingTop,
  closeIconStyle,
  ...props
}: any) => {
  const { children }: any = props;
  const { t } = useTranslation();
  const hasModalDescription = modalDescription != null && modalDescription !== "";
  const { classes } = useStyle({
    insideStyle,
    contentStyle,
    headerPadding,
    headerPaddingTop,
    isMiddleTitle,
    withClose,
    modalTitleColor,
    closeIconStyle,
    hasModalDescription,
  });

  return (
    <Modal disableEnforceFocus open={openModal} onClose={onClose} {...props}>
      <div style={classes.container}>
        <div className="gm-modal-head" style={classes.headerContainer}>
          {modalTitle != null && (
            hasModalDescription ? (
              <div style={classes.headerTitleWrapper}>
                <div
                  style={
                    isBlockModal
                      ? classes.titleBlockModalStyle
                      : { ...classes.titleModalStyle, ...modalTitleStyle }
                  }
                >
                  {modalTitle}
                </div>
                <div style={classes.headerDescriptionStyle}>{modalDescription}</div>
              </div>
            ) : (
              <div
                style={
                  isBlockModal
                    ? classes.titleBlockModalStyle
                    : { ...classes.titleModalStyle, ...modalTitleStyle }
                }
              >
                {modalTitle}
              </div>
            )
          )}
          {withClose && (
            <div style={classes.closeIcon} onClick={onClose}>
              <Tooltip title={t("modal.close")}>
                <IconButton
                  sx={
                    hasModalDescription
                      ? { width: 32, height: 32, padding: 0, color: "#1A1A1A" }
                      : undefined
                  }
                >
                  {withRoundedCloseIcon ? (
                    <RoundedCloseIcon />
                  ) : (
                    <CloseIcon
                      {...(hasModalDescription && {
                        width: 24,
                        height: 24,
                        color: "#1A1A1A",
                      })}
                    />
                  )}
                </IconButton>
              </Tooltip>
            </div>
          )}
        </div>
        <div style={classes.boxContainer} className={contentClassName}>
          {children}
        </div>
      </div>
    </Modal>
  );
};

export { GoMakeModal };
